import "./assets/css/app.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { ErrorBoundary } from "./components/errorBoundary";
import { RouteError } from "./components/routeError";
import { SignUp } from "./views/signUp";
import { Login } from "./views/login";
import { HomePage } from "./views/homePage";
import { RouterProvider, createBrowserRouter } from "react-router-dom";

export default function App() {
  const router = createBrowserRouter([
    {
      path: "/signup",
      element: <SignUp />,
      errorElement: <RouteError />,
    },
    {
      path: "/login",
      element: <Login />,
      errorElement: <RouteError />,
    },
    {
      path: "/",
      element: <HomePage />,
      errorElement: <RouteError />,
    },
  ]);

  return (
    <div>
      <ErrorBoundary>
        <RouterProvider router={router} />
        <ToastContainer className="toast-container" closeButton={false} />
      </ErrorBoundary>
    </div>
  );
}
